import { Buffer } from "buffer";
import { SOLANA_PROGRAM_ID } from "./solana";
import { LAMPORTS_PER_SOL, PublicKey, SystemProgram } from "@solana/web3.js";

export const createWertSolanaIx = (userAddress: string, amount: number, destinationToken: PublicKey, slippage: number) => {
    const [vaultPDA] = PublicKey.findProgramAddressSync(
        [Buffer.from('vault_authority')],
        new PublicKey(SOLANA_PROGRAM_ID)
    );

    const lamports = BigInt(Math.floor(amount * LAMPORTS_PER_SOL));
    const slippageLamports = 100;
    // Create the instruction data
    const data = Buffer.concat([
        // Instruction discriminator for deposit_sol (8 bytes)
        Buffer.from([108, 81, 78, 117, 125, 155, 56, 200]),
        // destinationToken (32 bytes)
        destinationToken.toBytes(),
        // amount as u64 (8 bytes, little-endian)
        Buffer.from(new Uint8Array(new BigUint64Array([lamports]).buffer)),
        // slippage as u16 (2 bytes, little-endian)
        Buffer.from(new Uint8Array(new Uint16Array([slippageLamports]).buffer)),
    ]);

    const instruction = {
        program_id: SOLANA_PROGRAM_ID,
        accounts: [
            {
                address: vaultPDA.toString(),
                is_signer: false,
                is_writable: true,
            },
            {
                address: userAddress.toString(),
                is_signer: false,
                is_writable: true,
            },
            {
                address: process.env.NEXT_PUBLIC_WERT_FUNDING_ACCOUNT,
                is_signer: true,
                is_writable: true,
            },
            {
                address: SystemProgram.programId.toString(),
                is_signer: false,
                is_writable: false,
            },
        ],
        data: data.toString("hex"),
    }

    return instruction;
};

export const createWertSolanaIxForSOL = (userAddress: string, amount: number) => {
    // instruction index for Transfer = 2 (not 0!)
    const TRANSFER_INSTRUCTION_INDEX = 2;
    const lamports = BigInt(amount * LAMPORTS_PER_SOL);

    // Allocate buffer: 4 bytes for index + 8 bytes for lamports
    const data = Buffer.alloc(12);

    // Write instruction index (little endian, u32)
    data.writeUInt32LE(TRANSFER_INSTRUCTION_INDEX, 0);

    // Write lamports (little endian, u64)
    data.writeBigUInt64LE(lamports, 4);

    const instruction = {
        program_id: "11111111111111111111111111111111",
        accounts: [
            {
                address: process.env.NEXT_PUBLIC_WERT_FUNDING_ACCOUNT,
                is_signer: true,
                is_writable: true,
            },
            {
                address: userAddress,
                is_signer: false,
                is_writable: true,
            }
        ],
        data: data.toString("hex"),
    }

    return instruction;
};
